export const EXTRA_DETAILS_QUESTIONS = [
  {
    "id": 1,
    "section": "Tâm lý",
    "sectionKey": "psych" as const,
    "q": "Khoảng thời gian bạn độc thân (hoặc không trong một mối quan hệ chính thức) tính đến nay là bao lâu?",
    "type": "radio",
    "options": [
      "Dưới 6 tháng",
      "Từ 6 tháng đến 2 năm",
      "Trên 2 năm",
      "Chưa từng có mối tình chính thức nào"
    ]
  },
  {
    "id": 2,
    "section": "Tâm lý",
    "sectionKey": "psych" as const,
    "q": "Mối quan hệ hiện tại của bạn với người yêu cũ (nếu có) đang ở trạng thái nào?",
    "type": "radio",
    "options": [
      "Cắt đứt hoàn toàn, coi như người lạ qua đường",
      "Vẫn giữ liên lạc xã giao bình thường vì công việc/bạn chung",
      "Vẫn là bạn thân, thường xuyên tâm sự và gặp gỡ",
      "Tôi chưa từng có người yêu cũ"
    ]
  },
  {
    "id": 3,
    "section": "Tâm lý",
    "sectionKey": "psych" as const,
    "q": "Khi xảy ra mâu thuẫn hoặc cãi vã trong tình yêu, phản ứng tự nhiên của bạn thường là gì?",
    "type": "radio",
    "options": [
      "Thẳng thắn lên tiếng, muốn nói chuyện rõ ràng để giải quyết ngay lập tức",
      "Im lặng vài tiếng hoặc một ngày để bình tĩnh lại rồi mới nói chuyện sau",
      "Né tránh, im lặng dài ngày (chiến tranh lạnh) hoặc biến mất để tự xoa dịu bản thân",
      "Dễ bị bộc phát cảm xúc (khóc, nói lời nặng nề) nhưng sau đó nhanh nguôi giận"
    ]
  },
  {
    "id": 4,
    "section": "Tâm lý",
    "sectionKey": "psych" as const,
    "q": "Khi dọn về sống chung, bạn mong muốn mình đóng vai trò nào trong việc quán xuyến gia đình?",
    "type": "radio",
    "options": [
      "Tôi muốn là người chủ động quyết định các việc lớn (định hướng, tài chính lớn, đối ngoại)",
      "Tôi thích lùi về sau, chăm sóc nhà cửa, nấu ăn, vun vén tổ ấm nhỏ",
      "Cả hai cùng bình đẳng, việc ai người đó làm, khi có việc lớn thì thảo luận 50/50",
      "Tuỳ thuộc vào nửa kia"
    ]
  },
  {
    "id": 5,
    "section": "Thực tế",
    "sectionKey": "practical" as const,
    "q": "Quan điểm của bạn về vật nuôi (Thú cưng) trong không gian sống chung?",
    "type": "radio",
    "options": [
      "Tôi đang nuôi thú cưng (Chó/Mèo) và coi chúng như con",
      "Tôi không nuôi nhưng yêu động vật, sẵn sàng nuôi chung với người yêu",
      "Tôi không ghét nhưng không muốn nuôi thú cưng trong nhà vì sợ bẩn/rụng lông",
      "Tôi bị dị ứng lông động vật / Tuyệt đối không thể sống chung với thú cưng"
    ]
  },
  {
    "id": 6,
    "section": "Thực tế",
    "sectionKey": "practical" as const,
    "q": "Mức độ ảnh hưởng của Tôn giáo / Tâm linh trong cuộc sống của bạn thế nào?",
    "type": "radio",
    "options": [
      "Rất quan trọng. Tôi là người có đạo hoặc rất tin vào phong thủy, thần số học, tử vi (Mong đối phương tôn trọng hoặc có cùng đức tin)",
      "Bình thường. Có thờ có thiêng có kiêng có lành, nhưng không để ảnh hưởng đến tình cảm",
      "Hoàn toàn không quan trọng. Tôi theo chủ nghĩa thực tế/vô thần",
      "Tôi không muốn kết nối với những người quá quan tâm đến tôn giáo /tâm linh"
    ]
  },
  {
    "id": 7,
    "section": "Thực tế",
    "sectionKey": "practical" as const,
    "q": "Bạn tự đánh giá thế nào về tình trạng sức khỏe tổng quát (thể chất & tinh thần) của mình hiện tại?",
    "type": "radio",
    "options": [
      "Rất tốt: Tôi có lối sống lành mạnh, tràn đầy năng lượng và tinh thần ổn định.",
      "Tốt: Sức khỏe ổn định, thỉnh thoảng có áp lực hoặc bệnh vặt nhưng tự cân bằng được.",
      "Bình thường: Nhìn chung là bình thường, có vài bệnh mãn tính nhưng không quá ảnh hưởng đến cuộc sống",
      "Có vấn đề về sức khoẻ hoặc tâm lý: Tôi đang có bệnh nền hoặc đang điều trị tâm lý, mong tìm một người bao dung, thấu hiểu."
    ]
  },
  {
    "id": 8,
    "section": "Thực tế",
    "sectionKey": "practical" as const,
    "q": "Tần suất bạn thực hiện kiểm tra sức khỏe tình dục (STDs/HIV) định kỳ là bao lâu?",
    "type": "radio",
    "options": [
      "3 - 6 tháng một lần (Rất kỹ tính và trách nhiệm)",
      "1 năm một lần / Hoặc trước khi bước vào mối quan hệ mới",
      "Chỉ đi khám khi cơ thể có dấu hiệu bất thường",
      "Tôi chưa từng đi kiểm tra"
    ]
  },
  {
    "id": 9,
    "section": "Tình Dục",
    "sectionKey": "sex" as const,
    "q": "Quan điểm và thói quen bảo vệ sức khỏe tình dục của bạn là gì?",
    "type": "radio",
    "options": [
      "Thường xuyên sử dụng PrEP - Thuốc dự phòng trước phơi nhiễm, Nên không cần dùng bao cao su.",
      "Luôn sử dụng bao cao su kể cả khi sử dụng PrEP - Thuốc dự phòng trước phơi nhiễm",
      "Chỉ quan hệ không an toàn khi cả hai đều an toàn",
      "Khá thoáng và linh hoạt tùy thuộc vào cảm xúc tại thời điểm đó"
    ]
  },
  {
    "id": 10,
    "section": "Tình Dục",
    "sectionKey": "sex" as const,
    "q": "Mức độ nhu cầu và tần suất quan hệ lý tưởng đối với bạn trong một mối quan hệ yêu đương là gì?",
    "type": "radio",
    "options": [
      "Nhu cầu cao (Thường xuyên: Khoảng 3 - 5 lần/tuần. Tình dục là chất xúc tác cốt lõi để giữ lửa tình yêu.)",
      "Nhu cầu vừa phải (Cân bằng: Khoảng 1 - 2 lần/tuần hoặc vào cuối tuần. Tập trung vào chất lượng hơn số lượng.)",
      "Nhu cầu thấp (Nhẹ nhàng: Vài tuần một lần hoặc chỉ khi cả hai thực sự thoải mái.)",
      "Thiên về tình cảm (Hạn chế/Không nhu cầu: Tôi chuộng cái ôm, nụ hôn, sự thấu hiểu tinh thần hơn là quan hệ thể xác.)"
    ]
  },
  {
    "id": 11,
    "section": "Tình Dục",
    "sectionKey": "sex" as const,
    "q": "Phong cách hoặc sở thích giường chiếu nào mô tả đúng nhất về bạn?",
    "type": "checkbox",
    "options": [
      "Lãng mạn / Truyền thống (Thích sự nhẹ nhàng, ngọt ngào, bật nhạc nến và tập trung vào cảm xúc (Vanilla)).",
      "Mãnh liệt / Chủ động (Thích sự hoang dại, nồng nhiệt, có phần lấn lướt và chiếm hữu cao)",
      "Thích trải nghiệm mới (Sẵn sàng thử các không gian mới, đồ chơi (sex-toys) hoặc nhập vai (Roleplay))",
      "Có gu đặc biệt (BDSM, hoặc thích một chút gia vị bạo lực nhẹ nhàng như bịt mắt, trói tay, Spanking khi có sự đồng thuận)",
      "Chỉ cần sự ấm áp (Không quan trọng cách thức, miễn là hai cơ thể được chạm vào nhau và cảm nhận sự an toàn)"
    ]
  },
  {
    "id": 12,
    "section": "Áp Lực",
    "sectionKey": "pressure" as const,
    "q": "Mức độ tử chủ hoặc phụ thuộc vào ý kiến của cha mẹ/gia đình khi bạn chọn người yêu ra sao?",
    "type": "radio",
    "options": [
      "100% tự quyết (gia đình không thể can thiệp vào hạnh phúc cá nhân của tôi)",
      "70% tự quyết (mong tìm một người khéo léo để sau này làm đẹp lòng cha mẹ)",
      "30% tự quyết (đang cố gắng tự chủ, mong tìm người mạnh mẽ đồng hành)",
      "0% (Gia đình rất khắt khe, người yêu của tôi bắt buộc phải qua được vòng kiểm duyệt của cha mẹ)"
    ]
  },
  {
    "id": 13,
    "section": "Áp Lực",
    "sectionKey": "pressure" as const,
    "q": "Bạn thoải mái đến mức nào với việc thể hiện tình cảm (nắm tay, ôm nhẹ, tương tác) ở nơi công cộng?",
    "type": "radio",
    "options": [
      "Chủ động bung lụa (Sẵn sàng chủ động thể hiện tình cảm ở bất cứ đâu)",
      "Thoải mái: (Tôi tự tin thể hiện tình cảm chừng mực ngoài đường, không bận tâm ánh mắt người lạ)",
      "Hạn chế (Chỉ thể hiện ở những không gian an toàn quán như cafe quen, rạp phim, du lịch xa. còn ngoài đường phố lớn thì nên giữ khoảng cách xã giao)",
      "Tuyệt đối không (Tôi muốn giữ kín hoàn toàn khi ra ngoài xã hội để bảo mật đời tư tối đa)"
    ]
  }
];

export const NARRATIVE_QUESTIONS = [
  "Khi gác lại công việc, một ngày nghỉ ngơi trọn vẹn của bạn thường được lấp đầy bởi những hoạt động nào?",
  "Nếu được tự khen ngợi bản thân một điều, bạn tự hào nhất về phẩm chất hoặc thói quen tốt nào của mình?",
  "Hãy vẽ nên kịch bản về một buổi hẹn hò lý tưởng có thể khiến bạn cảm thấy thoải mái và rung động nhất?",
  "Trong tình yêu, bạn mong muốn đối phương giao tiếp và chia sẻ với mình theo cách như thế nào?"
];

export const PERSONALITY_QUIZ = [
  {
    q: "Trạng thái năng lượng khi bạn xuất hiện tại một Lounge/Event đông người?",
    options: [
      { text: "Ngồi quầy Bar, gọi một ly Cocktails, lặng lẽ quan sát xung quanh và chỉ nói chuyện sâu với người hợp gu.", type: "A" },
      { text: "Diện một bộ Outfits thật \"mướt mắt\", tự tin giao tiếp, kết nối và trở thành tâm điểm của đám đông.", type: "B" },
      { text: "Đi cùng hội bạn thân, loay hoay chụp ảnh cho tụi nó, chủ động gọi đồ ăn thức uống bảo đảm không ai bị bỏ rơi.", type: "C" },
      { text: "Thích tụ tập ở một góc sofa ấm cúng, làm \"loa phóng thanh\" kể chuyện hài hước hoặc hóng drama cùng hội anh em.", type: "D" }
    ]
  },
  {
    q: "Khi dọn về chung một nhà với người yêu, bạn tự tin mình sẽ cân trọn việc nào nhất?",
    options: [
      { text: "Lên kế hoạch quản lý dòng tiền, quản lý chi phí hóa đơn và thiết kế lộ trình đi du lịch cho cả hai.", type: "A" },
      { text: "Chăm sóc diện mạo căn nhà, bật nhạc lofi, xông tinh dầu, bảo đảm không gian lúc nào cũng lãng mạn như khách sạn 5 sao.", type: "B" },
      { text: "Vào bếp nấu những món tủ hằng ngày, dọn dẹp nhà cửa gọn gàng, sẵn sàng mát-xa cho người yêu sau ngày làm việc mệt mỏi.", type: "C" },
      { text: "Là người giữ lửa tiếng cười, bài trừ sự nhàm chán, thỉnh thoảng rủ người yêu trốn nhà đi \"đổi gió\" ở homestay xa.", type: "D" }
    ]
  },
  {
    q: "Cách bạn \"bật đèn xanh\" rõ ràng nhất cho người bạn đang thầm thích là gì?",
    options: [
      { text: "Thăm dò sở thích, công việc của họ để mở lời bằng một chủ đề tri thức, sâu sắc mà họ quan tâm.", type: "A" },
      { text: "Tương tác dồn dập trên MXH, thả tim Story hằng ngày, rủ đi xem phim, đi date thẳng thắn không lòng vòng.", type: "B" },
      { text: "Tự tay chuẩn bị một món quà nhỏ đúng gu họ, hoặc ngầm đưa đón, lo lắng cho họ từ những điều vụn vặt nhất.", type: "C" },
      { text: "Rep tin nhắn cực nhanh bằng những meme (ảnh hài) mặn mòi, trêu chọc một cách duyên dáng khiến họ cười cả ngày.", type: "D" }
    ]
  },
  {
    q: "Khi đối phương đột ngột im lặng hoặc gặp áp lực công việc nặng nề, bạn sẽ xử lý thế nào?",
    options: [
      { text: "Tôn trọng không gian riêng của họ, giữ khoảng cách vừa đủ và nhắn: \"Khi nào cần giải pháp, em luôn ở đây\".", type: "A" },
      { text: "Mua một bó hoa hoặc một món quà bất ngờ, chạy qua ôm chặt vỗ về để họ cảm thấy không cô đơn.", type: "B" },
      { text: "Nấu một bát súp nóng (hoặc đặt đồ ăn họ thích), dặn dò uống nước, lo liệu mọi việc xung quanh để họ yên tâm nghỉ ngơi.", type: "C" },
      { text: "Rủ họ đi nhậu đổi gió, kể chuyện tếu táo hoặc tìm cách kéo họ ra ngoài không gian ngột ngạt để giải khuây.", type: "D" }
    ]
  },
  {
    q: "Ranh giới đỏ (Red Flag) nào trong giao tiếp khiến bạn lập tức \"quay xe\" cắt liên lạc?",
    options: [
      { text: "Nói chuyện phông bạt, tư duy nông cạn hoặc thiếu kiến thức nền tảng tối thiểu.", type: "A" },
      { text: "Nhắn tin nhạt nhẽo, rep chậm như rùa bò, không có chút chủ động nào trong mối quan hệ.", type: "B" },
      { text: "Cư xử thô lỗ với những người xung quanh (phục vụ, tài xế) hoặc có lối sống quá ích kỷ, cẩu thả.", type: "C" },
      { text: "Quá nghiêm túc, cứng nhắc, đùa một chút cũng tự ái và không biết tận hưởng niềm vui cuộc sống.", type: "D" }
    ]
  }
];

export type PersonalityVariantKey =
  | 'A1' | 'A2' | 'A3'
  | 'B1' | 'B2' | 'B3'
  | 'C1' | 'C2' | 'C3'
  | 'D1' | 'D2' | 'D3';

export const PERSONALITY_VARIANTS: Record<
  PersonalityVariantKey,
  { shareTitle: string; shareHook: string }
> = {
  A1: {
    shareTitle: '#Chất_Gây_Nghiện_Bí_Ẩn | #Kẻ_Thao_Túng_Khoảng_Lặng',
    shareHook:
      'Thế giới ngoài kia đã quá ồn ào rồi. Nếu anh cũng mệt mỏi với những thứ hào nhoáng hời hợt, thì dừng chân ở đây, mình cùng tạo một khoảng lặng bình yên nhé.',
  },
  A2: {
    shareTitle: '#ỐC_ĐẢO_TƯ_DUY | #BẬC_THẦY_QUAN_SÁT',
    shareHook:
      'Sự điềm đạm và phông văn hóa tri thức tự nó đã là một sức hút chí mạng. Không cần nói to, người cùng tần số khắc tự va vào nhau. 🧠',
  },
  A3: {
    shareTitle: '#MẬT_MÃ_TÌNH_CẢM | #HỆ_ĐIỀU_HÀNH_LÝ_TRÍ',
    shareHook:
      'Yêu tôi thì không lo drama, chỉ có sự bình yên vững chãi và một lộ trình tương lai rõ ràng. Ai tự tin giải được mật mã này thì nhào vô! 🔐',
  },
  B1: {
    shareTitle: '#Nam_Thần_Phủ_Sóng | #Thỏi_Nam_Châm_Date_VIP',
    shareHook:
      'Yêu là phải cháy, không thích mập mờ. Ai muốn một cuộc tình ngập tràn bất ngờ và lãng mạn 5 sao thì xếp hàng từ bây giờ nha!',
  },
  B2: {
    shareTitle: '#MẶT_TRỜI_ĐÊM_LOUNGE | #CHIẾN_THẦN_CHỦ_ĐỘNG',
    shareHook:
      'Đã nhắm trúng ai là bật đèn xanh đường đường chính chính. Cuộc sống này quá ngắn để chơi trò trốn tìm, thích là phải nhích! ⚡',
  },
  B3: {
    shareTitle: '#THỔI_BÙNG_CẢM_XÚC | #VIP_DATER_CHÍ_MẠNG',
    shareHook:
      'Bên cạnh tôi thì deadline có thể chán chứ tình yêu thì không bao giờ nhạt. Sẵn sàng dắt tay anh trốn cả thế giới đi đổi gió! 🥂',
  },
  C1: {
    shareTitle: '#Gấu_Gia_Đình_Quốc_Dân | #Nóc_Nhà_Bình_Yên',
    shareHook:
      'Ngoài đời có là cá mập thì về nhà vẫn có cơm ngon canh ngọt đợi sẵn. Tìm một người chịu dọn về chung một nhà để tôi nuông chiều đây.',
  },
  C2: {
    shareTitle: '#TRẠM_SẠC_BÌNH_YÊN | #ĐẠI_SỨ_NUÔNG_CHIỀU',
    shareHook:
      'Thế giới ngoài kia làm anh mệt mỏi rồi đúng không? Lại đây tôi ôm một cái, cơm nước áo ấm hằng đêm cứ để tôi lo trọn gói! 🍳',
  },
  C3: {
    shareTitle: '#BẾN_ĐỖ_AN_TOÀN | #KẺ_CHỮA_LÀNH_THẦM_LẶNG',
    shareHook:
      'Biểu hiện tình yêu bằng hành động thực tế chứ không bằng lời chót lưỡi đầu môi. Xứng đáng là điểm dừng chân cuối cùng của một đời người. 🧸',
  },
  D1: {
    shareTitle: '#Vitamin_Mặn_Mòi | #Chiến_Thần_Chữa_Lành',
    shareHook:
      'Cuộc đời đã đủ deadline mệt mỏi rồi, yêu tôi đi để ngày nào cũng được cười nách. Nhấn nút đăng ký làm người yêu ngay để nhận ưu đãi!',
  },
  D2: {
    shareTitle: '#CHÚA_TỂ_MỜI_NHẬU | #LOA_PHÓNG_THANH_DRAMA',
    shareHook:
      'Cuộc sống độc thân thì tự do, nhưng nếu có thêm một đồng đội mặn mòi để cùng đi quẩy, cùng hóng biến mỗi tối thì còn vui gấp đôi! 🍻',
  },
  D3: {
    shareTitle: '#LIÊM_SỈ_BAY_MÀU | #THẦN_DÂN_TIẾNG_CƯỜI',
    shareHook:
      'Ngoan ngoãn mãi rồi, tầm này ai cứu được cái sự mặn mòi này của tôi không? Đăng ký làm người yêu ngay để nhận rổ tiếng cười mỗi ngày! 🎢',
  },
};

export const PERSONALITY_RESULTS = {
  A: {
    title: "Hướng nội / Kín tiếng / Sâu sắc",
    shareTitle: "#Chất_Gây_Nghiện_Bí_Ẩn | #Kẻ_Thao_Túng_Khoảng_Lặng",
    shareHook: "Thế giới ngoài kia đã quá ồn ào rồi. Nếu anh cũng mệt mỏi với những thứ hào nhoáng hời hợt, thì dừng chân ở đây, mình cùng tạo một khoảng lặng bình yên nhé.",
    desc: "Bạn sở hữu năng lượng của một \"Ốc đảo bình yên\". Bạn không cần phải là người nói to nhất trong căn phòng để thu hút sự chú ý, bởi vì sự điềm đạm, low-key và phông văn hóa tri thức của bạn tự nó đã là một thứ nam châm có sức hút chí mạng. Trong tình yêu, bạn là người cực kỳ chung thủy, sâu sắc và biết trân trọng những giá trị nguyên bản. Ai có được tình yêu của bạn là sở hữu được một báu vật bách niên giai lão."
  },
  B: {
    title: "Năng lượng rực rỡ & Sức hút đám đông",
    shareTitle: "#Nam_Thần_Phủ_Sóng | #Thỏi_Nam_Châm_Date_VIP",
    shareHook: "Yêu là phải cháy, không thích mập mờ. Ai muốn một cuộc tình ngập tràn bất ngờ và lãng mạn 5 sao thì xếp hàng từ bây giờ nha!",
    desc: "Trái tim bạn rực lửa và tràn đầy sự dạn dĩ. Bạn là người định nghĩa lại khái niệm lãng mạn. Một khi đã nhắm trúng ai, bạn sẽ bật đèn xanh một cách đường đường chính chính và ngập tràn năng lượng chủ động. Bên cạnh bạn, đối phương sẽ không bao giờ cảm thấy bị bỏ rơi hay nhàm chán, cuộc sống của hai người sẽ là một chuỗi những chuyến đi và trải nghiệm ngọt ngào."
  },
  C: {
    title: "Bản năng che chở & Tổ ấm vững chãi",
    shareTitle: "#Gấu_Gia_Đình_Quốc_Dân | #Nóc_Nhà_Bình_Yên",
    shareHook: "Ngoài đời có là cá mập thì về nhà vẫn có cơm ngon canh ngọt đợi sẵn. Tìm một người chịu dọn về chung một nhà để tôi nuông chiều đây.",
    desc: "Bạn là sinh vật quý hiếm trong thời đại số — người biểu hiện tình yêu bằng hành động thực tế chứ không bằng lời nói chót lưỡi đầu môi. Nấu ăn ngon, biết lắng nghe, lo lắng từ chiếc áo ấm đến cốc nước ấm hằng đêm cho người yêu là đặc quyền của ai có được bạn. Bạn mang lại cảm giác an toàn tuyệt đối, xứng đáng là bến đỗ cuối cùng của một tình yêu đích thực."
  },
  D: {
    title: "Trí tuệ hài hước & Tự do bất tận",
    shareTitle: "#Vitamin_Mặn_Mòi | #Chiến_Thần_Chữa_Lành",
    shareHook: "Cuộc đời đã đủ deadline mệt mỏi rồi, yêu tôi đi để ngày nào cũng được cười nách. Nhấn nút đăng ký làm người yêu ngay để nhận ưu đãi!",
    desc: "Bạn sở hữu \"Trí tuệ hài hước\" — thứ tài sản quyến rũ bậc nhất trong giới. Bạn có khả năng biến mọi tình huống ngột ngạt trở nên nhẹ nhàng bằng một câu đùa duyên dáng. Bạn độc lập, yêu tự do và luôn biết cách tận hưởng cuộc sống một cách thú vị nhất. Ai yêu được bạn giống như sở hữu một nguồn năng lượng chữa lành vô hạn cho tâm hồn."
  }
};

export const FROZEN_HEART_META = {
  title: 'TRÁI TIM BĂNG GIÁ: GIẢI MÃ LỜI NGUYỀN ĐỘC THÂN',
  subtitle: 'The Frozen Heart',
  intro:
    'Bạn đang độc thân vì gu quá cao, vì những vết xước trong quá khứ chưa lành, hay đơn giản là vì... lười bước ra khỏi chiếc giường êm ái? Trái tim bạn đang ở "mức nhiệt" nào trong thế giới người độc thân? Hãy dành 2 phút giải mã tần số đóng băng của bản thân để nhận ngay "Tấm thẻ hồ sơ độc bản" cực chất để thả thính mạng xã hội!',
  notices: [
    'Bài test gồm 10 câu hỏi trắc nghiệm tâm lý ẩn, được thiết kế riêng cho cộng đồng.',
    'Hãy trả lời theo phản xạ tự nhiên và thành thật nhất với chính mình (không ai nhìn thấy câu trả lời của bạn ngoài hệ thống bảo mật ngầm).',
    'Thời gian ước tính: 90 giây.',
  ],
};

export const FROZEN_HEART_TAG_D = {
  badge: '⚠️ WARNING: LOWKEY LOVER - RÀO CẢN ĐỜI TƯ CAO',
  cardBadge: '⚠️ WARNING: LOWKEY LOVER',
  supplement:
    'Hệ thống quét thấy bạn đang chịu áp lực rất lớn về rào cản gia đình/xã hội hoặc vị trí công việc bắt buộc phải giữ lối sống kín tiếng (Bóng kín). Bạn không dám tiến tới vì sợ làm khổ đối phương hoặc sợ lộ danh tính đời tư. Bạn cần một người yêu thuộc nhóm Low-key/Kín tiếng tương tự, người thấu hiểu và chấp nhận một tình yêu bình lặng, không phô trương nhưng bền bỉ. Chúng tôi có tệp khách hàng tri thức, bóng kín giống bạn để kết nối bảo mật tuyệt đối 100%.',
};

export const SINGLE_QUIZ = [
  {
    q: 'Khi lướt thấy một hồ sơ nam có ngoại hình cực kỳ đúng gu, công việc xịn mịn, phản ứng đầu tiên của bạn là gì?',
    options: [
      { text: 'Bấm vào xem và soi thật kỹ, kiểm tra xem họ có điểm nào chưa khớp với tiêu chuẩn của mình không.', type: 'A' },
      { text: 'Nghĩ bụng chắc họ "phông bạt" hoặc thuộc hệ trap-boy thôi, hoàn hảo thế này không đến lượt mình → Thoát ra.', type: 'B' },
      { text: 'Thả tim một cái rồi lướt qua luôn, lười nhắn tin bắt chuyện hay làm quen lại từ đầu quá.', type: 'C' },
    ],
  },
  {
    q: 'Cuối tuần lý tưởng của bạn thường diễn ra như thế nào trong 6 tháng qua?',
    options: [
      { text: 'Đi lùng các quán cafe sang chảnh mới, đi xem triển lãm hoặc đi date nếu tìm được người xứng tầm.', type: 'A' },
      { text: 'Chỉ đi cafe với đúng 1-2 đứa bạn thân chí cốt, nói những câu chuyện cũ để cảm thấy an toàn.', type: 'B' },
      { text: 'Ngủ nướng, gọi đồ ăn về nhà, xem phim, lướt mạng hết ngày. Chỉ ra đường khi bất khả kháng.', type: 'C' },
    ],
  },
  {
    q: 'Hãy nghĩ về mối tình gần nhất của bạn (hoặc người bạn từng mập mờ), lý do dừng lại là gì?',
    options: [
      { text: 'Nhạt dần rồi thôi, hoặc tôi nhận ra họ có vài điểm không đúng tiêu chuẩn của mình nên chủ động rút.', type: 'A' },
      { text: 'Tôi bị cắm sừng, tổn thương nặng nề hoặc họ đột ngột biến mất (Ghosting) khiến tôi ám ảnh.', type: 'B' },
      { text: 'Tôi chưa từng có mối tình nào đúng nghĩa, quanh năm chỉ đơn phương hoặc mập mờ được vài tuần.', type: 'C' },
    ],
  },
  {
    q: 'Bạn có một danh sách các tiêu chuẩn về người yêu tương lai (Tuổi, thu nhập, ngoại hình, role...). Mức độ linh hoạt của bạn là?',
    options: [
      { text: 'Cứng rắn 100%. Thiếu một tiêu chuẩn tôi cũng không cưới, thà ở vậy bảo toàn giá trị còn hơn hạ giá.', type: 'A' },
      { text: 'Có thể bớt một chút tiêu chuẩn mềm, nhưng người đó phải cho tôi cảm giác an toàn, không được lăng nhăng.', type: 'B' },
      { text: 'Sao cũng được, chỉ cần có cảm xúc và chịu được cái tính lười ra đường của tôi là được.', type: 'C' },
    ],
  },
  {
    q: 'Nếu được chọn một câu để mô tả về trạng thái độc thân hiện tại của bạn, đó là câu nào?',
    options: [
      { text: '"Tôi thà cô đơn trong hoàng nhoáng còn hơn phải chịu đựng một mối quan hệ không xứng tầm."', type: 'A' },
      { text: '"Tôi vừa thèm cảm giác được yêu thương, vừa sợ trao tình cảm nhầm người rồi lại bị bỏ rơi."', type: 'B' },
      { text: '"Tôi rất muốn có bồ, nhưng nghĩ đến việc phải đi làm quen, rep tin nhắn từ đầu thấy mệt quá."', type: 'C' },
    ],
  },
  {
    q: 'Cách bạn đối phó với áp lực lập gia đình từ bố mẹ/họ hàng hiện nay là gì?',
    options: [
      { text: 'Đối thoại thẳng thắn hoặc đã come out để đòi quyền tự quyết cuộc sống, ai nói gì mặc kệ.', type: 'A' },
      { text: 'Cảm thấy mệt mỏi, áp lực chồng chất, chọn cách im lặng hoặc trốn tránh không muốn về quê.', type: 'B' },
      { text: 'Đang âm thầm tìm kiếm các phương án kết hôn giả/hợp đồng để đối phó đời tư.', type: 'C', triggerTagD: true },
    ],
  },
  {
    q: 'Khi một người nhắn tin làm quen với bạn trên mạng, điều gì dễ khiến bạn "bỏ rep" (block/unmatch) nhất?',
    options: [
      { text: 'Nhắn tin nhạt nhẽo, nói chuyện thiếu phông văn hóa hoặc suốt ngày "Em ăn cơm chưa".', type: 'A' },
      { text: 'Nhắn vài câu đã vồ vập đòi xin ảnh nhạy cảm, rủ đi khách sạn hoặc hỏi dồn dập quyền riêng tư.', type: 'B' },
      { text: 'Rep tin nhắn chậm (mấy tiếng mới rep một lần), làm tôi tụt hết hứng thú để duy trì cuộc trò chuyện.', type: 'C' },
    ],
  },
  {
    q: 'Thử tưởng tượng bạn dọn về sống chung với người yêu, điều gì làm bạn lo sợ nhất?',
    options: [
      { text: 'Sợ mâu thuẫn về quản lý tiền bạc, phân chia tài chính chung và các thói quen chi tiêu lệch pha.', type: 'A' },
      { text: 'Sợ yêu nhau lâu bị chán, họ sẽ có xu hướng đi tìm người thứ ba hoặc đòi bẻ lái sang Open Relationship.', type: 'B' },
      { text: 'Sợ mất đi sự tự do, không gian riêng tư hằng ngày (đi đâu, làm gì, chơi game cũng phải báo cáo).', type: 'C' },
    ],
  },
  {
    q: 'Mức độ tự tin về ngoại hình và năng lực tài chính hiện tại của bạn nằm ở mức nào?',
    options: [
      { text: 'Khá tự tin, tôi độc lập tài chính và biết chăm sóc ngoại hình, xứng đáng có người yêu giỏi tương đương.', type: 'A' },
      { text: 'Tôi thấy mình cần phải giảm cân, kiếm nhiều tiền hơn nữa hoặc hoàn thiện bản thân thì mới dám yêu.', type: 'B' },
      { text: 'Bình thường, đủ dùng, không có gì quá nổi bật nhưng sống thoải mái.', type: 'C' },
    ],
  },
  {
    q: 'Tần suất bạn gặp gỡ và quen biết thêm "người mới hoàn toàn" trong giới (ngoài công việc) là bao lâu?',
    options: [
      { text: 'Vài tháng một lần, chủ yếu qua các mối quan hệ chất lượng hoặc bạn bè VIP giới thiệu.', type: 'A' },
      { text: 'Thỉnh thoảng quẹt app hẹn hò khi thấy cô đơn, nhưng hầu như chẳng bao giờ hẹn gặp ngoài đời.', type: 'B' },
      { text: 'Gần như bằng 0. Quanh năm suốt tháng chỉ đi làm rồi về nhà, vòng tròn xã hội đóng băng.', type: 'C' },
    ],
  },
];

export type FrozenHeartVariantKey =
  | 'A1' | 'A2' | 'A3'
  | 'B1' | 'B2' | 'B3'
  | 'C1' | 'C2' | 'C3';

export const BEDROOM_QUIZ = [
  {
    q: 'Tần suất "quét Radar" tìm kiếm các cực phẩm (trai đẹp) của bạn trên mạng xã hội hoặc ngoài đời như thế nào?',
    options: [
      { text: 'Khá thụ động. Chỉ khi nào có ai đó quá nổi bật xuất hiện trước mắt thì mới nhìn, bình thường không chủ động tìm kiếm.', type: 'A' },
      { text: 'Hệ điều hành kín tiếng (Low-key). Bề ngoài tỏ ra thờ ơ nhưng ngầm lưu ảnh, follow bằng tài khoản ẩn danh của các cực phẩm.', type: 'B' },
      { text: 'Bật chế độ quét 24/7. Thấy trai đẹp là mắt sáng lên, chủ động thả tim dồn dập, tương tác không bỏ sót một ai.', type: 'C' },
      { text: 'Xem giải trí là chính. Thấy ai đẹp thì rủ hội anh em cùng vào hóng biến, bàn luận tếu táo cho vui nhà vui cửa.', type: 'D' },
    ],
  },
  {
    q: 'Nếu phải dùng một thuật ngữ công nghệ để mô tả về "phần cứng" của bản thân, bạn sẽ chọn từ nào?',
    options: [
      { text: 'Bản thiết kế thanh lịch. Vừa vặn, chú trọng vào tính thẩm mỹ và sự hài hòa tổng thể.', type: 'A' },
      { text: 'Cấu hình ẩn giấu (Stealth Edition). Nhìn bình thường nhưng khi kích hoạt sẽ bung hiệu năng cực kỳ bất ngờ.', type: 'B' },
      { text: 'Bản Ép xung tối đa (Ultra Overclocked). Kích thước khủng, hoành tráng, là niềm tự hào của nhà sản xuất.', type: 'C' },
      { text: 'Bản bỏ túi tiện lợi (Compact Edition). Nhỏ gọn, tiết kiệm không gian, dễ dàng vận hành trong mọi địa hình.', type: 'D' },
    ],
  },
  {
    q: 'Dung lượng pin "vận hành phòng ngủ" của bạn trong một đêm thường đạt mức nào?',
    options: [
      { text: 'Chế độ Eco (Êm ái). Thao tác nhẹ nhàng, một hiệp chất lượng rồi ôm nhau ngủ đến sáng là đủ bình yên.', type: 'A' },
      { text: 'Chế độ sạc nhồi. Hiệp một có thể trôi qua nhanh nhưng nghỉ ngơi một chút là có thể nạp năng lượng chiến tiếp hiệp hai.', type: 'B' },
      { text: 'Trùm cày đêm (Pin trâu 5000mAh). Sẵn sàng "cày deadline" nhiều hiệp, bền bỉ xuyên đêm không biết mệt mỏi là gì.', type: 'C' },
      { text: 'Công nghệ sạc nhanh (Fast Charge). Tốc độ giải quyết nhanh gọn lẹ trong 15 phút, ưu tiên hiệu suất để thời gian còn lại nghỉ ngơi.', type: 'D' },
    ],
  },
  {
    q: 'Khi "bật máy" lâm trận, phong cách vận hành yêu thích của bạn là gì?',
    options: [
      { text: 'Chế độ chăm sóc khách hàng. Luôn hỏi han, nhẹ nhàng, sợ đối phương đau và thích những cái ôm dỗ dành.', type: 'A' },
      { text: 'Chế độ lật kèo phút chót. Ban đầu giả vờ ngoan ngoãn để đối phương chủ quan, sau đó lật ngược thế cờ chiếm thế thượng phong.', type: 'B' },
      { text: 'Chế độ Sport Plus (Bạo liệt). Thích chiếm hữu, mạnh bạo, một chút kinky/tổn thương nhẹ và đam mê cảm giác kích thích mạnh.', type: 'C' },
      { text: 'Chế độ vừa đi vừa diễn hài. Thỉnh thoảng đang cao trào vẫn có thể bật cười vì một tình huống tếu táo, không áp lực chuyện thắng thua.', type: 'D' },
    ],
  },
  {
    q: 'Trong suy nghĩ hoặc những giấc mơ thầm kín nhất, mức độ bạn tưởng tượng về các kịch bản "tắt đèn" táo bạo như thế nào?',
    options: [
      { text: 'Rất hiếm khi. Tôi thuộc trường phái lãng mạn truyền thống, chỉ khi hai người yêu nhau sâu đậm và có không gian hoàn hảo thì cảm xúc mới đến.', type: 'A' },
      { text: 'Thỉnh thoảng có nghĩ tới nhưng giữ cho riêng mình. Thích kịch bản mập mờ, trêu đùa bằng ánh mắt hoặc văn bản (Texting/Dirty talk).', type: 'B' },
      { text: 'Nghĩ đến thường xuyên và cực kỳ phong phú. Đam mê các kịch bản nhập vai (Roleplay), những địa điểm mới lạ hoặc cảm giác bùng nổ.', type: 'C' },
      { text: 'Ý tưởng nhảy số liên tục nhưng mang tính lầy lội là chính. Thích xem các nội dung 18+ hài hước, coi tình dục là bộ môn giải trí lành mạnh.', type: 'D' },
    ],
  },
  {
    q: 'Sau khi "tắt máy" kết thúc một buổi tối nồng nhiệt, hành động nào khiến bạn mãn nguyện nhất?',
    options: [
      { text: 'Cùng nhau đi tắm, sau đó đắp chăn nằm tâm sự mỏng về cuộc sống cho đến khi chìm vào giấc ngủ.', type: 'A' },
      { text: 'Nhìn biểu cảm mệt nhoài nhưng thỏa mãn của đối phương và tự hào vì mình vừa "tối ưu phần mềm" quá tốt.', type: 'B' },
      { text: 'Giữ nguyên sự chiếm hữu, ôm thật chặt không cho đối phương cựa quậy, hoặc tiếp tục suy nghĩ về kịch bản cho lần sau.', type: 'C' },
      { text: 'Cùng nhau bật dậy đặt ngay một ly trà sữa hoặc đồ ăn đêm về ăn uống no nê, vừa ăn vừa cười nách.', type: 'D' },
    ],
  },
];

export const BEDROOM_RESULTS = {
  A: {
    title: 'Team Ngoan Hiền / Êm Ái',
    desc: 'Bạn thuộc trường phái yêu thương nhẹ nhàng, tinh tế. Tắt đèn là lúc để được nuông chiều và cùng nhau tận hưởng sự bình yên.',
  },
  B: {
    title: 'Team Low-key / Ngoài Ngoan Trong Dâm',
    desc: 'Bề ngoài chuẩn mực, kín tiếng. Bên trong lại sở hữu một thế giới phòng ngủ phong phú và đầy bất ngờ.',
  },
  C: {
    title: 'Team Chiến Thần Phòng Ngủ',
    desc: 'Bạn là người có năng lượng bùng nổ, thích sự chiếm hữu và những trải nghiệm mạnh mẽ, táo bạo.',
  },
  D: {
    title: 'Team Hài Hước / Hiệu Suất Cao',
    desc: 'Bạn coi chuyện ấy là một phần của niềm vui và tiếng cười. Hiệu suất cao, không áp lực, và luôn có không khí vui vẻ.',
  },
};

export const BEDROOM_VARIANTS: Record<
  string,
  { shareTitle: string; shareHook: string }
> = {
  // A
  A1: {
    shareTitle: '#MÈO_CON_HƯỚNG_NỘI | #HỆ_ĐIỀU_HÀNH_CHAY',
    shareHook: '“Trên giường em là chú mèo ngoan, tắt đèn chỉ thích ôm ngủ. Đừng bắt em làm bạo chúa, em chỉ muốn được nuông chiều thôi! 🧸”',
  },
  A2: {
    shareTitle: '#TÌNH_YÊU_THUẦN_KHIẾT | #PREMIUM_SOFT_VIBE',
    shareHook: '“Mạnh bạo không phải gu của tôi. Sự tinh tế, chậm rãi và những nụ hôn sâu mới là chìa khóa để kích hoạt trái tim này. 🥂”',
  },
  A3: {
    shareTitle: '#HOÀNG_TỬ_BÌNH_YÊN | #BẢN_THIẾT_KẾ_LÃNG_MẠN',
    shareHook: '“Thế giới ngoài kia cày deadline đủ mệt rồi, tắt đèn bật chế độ Eco êm ái, nhẹ nhàng yêu nhau thôi anh nhé! 🕊️”',
  },
  // B
  B1: {
    shareTitle: '#QUÁI_VẬT_MẶC_SƠ_MI | #CHÚA_TỂ_LẬT_KÈO',
    shareHook: '“Đừng để vẻ bề ngoài low-key của tôi đánh lừa. Bước vào phòng ngủ, tôi sẽ bật chế độ \'Sport Plus\' khiến bạn không kịp trở tay đâu! ⚡”',
  },
  B2: {
    shareTitle: '#MẬT_MÃ_GIƯỜNG_CHIẾU | #TỔNG_TÀI_ẨN_DANH',
    shareHook: '“Bên ngoài chuẩn mực tri thức, bên trong sở hữu kho ý tưởng giường chiếu phong phú kinh ngạc. Muốn khám phá thì phải kiên nhẫn bóc từng lớp nhé! 🔐”',
  },
  B3: {
    shareTitle: '#BẬC_THẦY_TEXTING | #DÂM_ĐÃNG_CÓ_HỌC_THỨC',
    shareHook: '“Kích thích trí não bằng dirty talk đỉnh cao trước khi lâm trận. Đã không bật máy thì thôi, một khi đã vào việc là hiệu năng bung xõa bất ngờ! 🧠”',
  },
  // C
  C1: {
    shareTitle: '#BẠO_CHÚA_PHÒNG_NGỦ | #OVERCLOCKED_MASTER',
    shareHook: '“Cấu hình VIP, xung nhịp cao, một đêm cày deadline không biết mệt. Ai chịu được chế độ vận hành bạo liệt này thì nộp đơn ứng tuyển! 🔥”',
  },
  C2: {
    shareTitle: '#THỎI_NAM_CHÂM_18+ | #RADAR_DÒ_TRAI_ĐẸP',
    shareHook: '“Mắt tôi có radar tự động quét trai đẹp trong bán kính 5km. Gu mặn mòi, thích chiếm hữu và đam mê những kịch bản bùng cháy! ⛓️”',
  },
  C3: {
    shareTitle: '#QUÁI_VẬT_THỂ_CHẤT | #HỆ_THỐNG_CHIẾM_HỮU',
    shareHook: '“Yêu là phải bạo, phải cháy hết mình từ ánh mắt đến da thịt. Sức bền vô hạn, sẵn sàng thao túng căn phòng ban đêm của bạn! 🦁”',
  },
  // D
  D1: {
    shareTitle: '#SẠC_NHANH_15_PHÚT | #THẦN_DÂN_HIỆU_SUẤT',
    shareHook: '“Thời gian quý báu như vàng bạc, tôi chọn lối sống hiệu suất cao, giải quyết nhanh gọn lẹ trong 15 phút rồi ôm nhau ngủ cho khỏe người! 🔋”',
  },
  D2: {
    shareTitle: '#COMPACT_EDITION | #CHÚA_TỂ_TIẾT_KIỆM_KHÔNG_GIAN',
    shareHook: '“Nồi nào úp vung nấy, cấu hình \'bỏ túi\' nhỏ gọn tiện lợi tìm kiếm một vung nồi vừa vặn để cùng bật chế độ êm ái qua đêm. 📦”',
  },
  D3: {
    shareTitle: '#VITAMIN_MẶN_MÒI_18+ | #HÀI_HƯỚC_TRÊN_GIƯỜNG',
    shareHook: '“Áp lực deadline đủ mệt rồi, lên giường là phải vui vẻ, thoải mái cười nách. Đăng ký làm người yêu ngay để vừa được sướng vừa được cười hằng đêm! 🎢”',
  },
};

export const FROZEN_HEART_VARIANTS: Record<
  FrozenHeartVariantKey,
  { shareTitle: string; shareHook: string }
> = {
  A1: {
    shareTitle: '#ĐỘC_THÂN_QUÝ_TỘC',
    shareHook:
      'Không phải tôi ế, là do thị trường chưa sản xuất ra người xứng đáng với cấu hình này thôi. Tiêu chuẩn cao thì có gì là sai? 😎',
  },
  A2: {
    shareTitle: '#CHÚA_TỂ_YÊU_CẦU',
    shareHook:
      'Thà cô đơn trong huy hoàng còn hơn chịu đựng một mối quan hệ lệch pha. Bản lĩnh của tôi là nói \'Không\' với sự hời hợt! 🥂',
  },
  A3: {
    shareTitle: '#RADAR_SÁNG_SUỐT',
    shareHook:
      'Yêu tôi thì không lo drama, chỉ có sự bình yên và những kế hoạch rõ ràng. Ai tự tin đúng tần số thì nhào vô kiểm chứng! 📐',
  },
  B1: {
    shareTitle: '#CÀNH_CONG_SỢ_CHIM',
    shareHook:
      'Trái tim này tạm thời đóng cửa để bảo trì sau vài trận bão lòng. Tìm một người đủ kiên nhẫn đến rã đông... 🩹',
  },
  B2: {
    shareTitle: '#ĐẠI_SỨ_CẨN_TRỌNG',
    shareHook:
      'Băng dày là để tự vệ chứ không phải tuyệt tình. Tôi không vội, một tình yêu chậm mà chắc sẽ xứng đáng để chờ đợi. 🛡️',
  },
  B3: {
    shareTitle: '#TÂM_HỒN_Ủ_ẤM',
    shareHook:
      'Bên ngoài tỏ ra rụt rè vô cảm, bên trong thực chất là bão táp ngầm. Cần một cái ôm an toàn hơn vạn lời mật ngọt. 🕯️',
  },
  C1: {
    shareTitle: '#CHIẾN_THẦN_Ủ_KÉN',
    shareHook:
      'Thần tình yêu gõ cửa trúng lúc tôi đang bận ngủ nướng. Ai có lòng thì tự dắt tôi ra khỏi nhà chứ tôi lười làm quen lắm rồi! 🛌',
  },
  C2: {
    shareTitle: '#NGHIỆN_NHÀ_TAY_TO',
    shareHook:
      'Bán kính hoạt động cuối tuần: Từ giường ra đến tủ lạnh. Muốn có người thương nhưng ngại ra đường làm quen, ai ship bồ đến hộ với! 🍕',
  },
  C3: {
    shareTitle: '#ỐC_ĐẢO_BÌNH_YÊN',
    shareHook:
      'Thế giới ngoài kia cày deadline mệt rồi, về nhà tôi nấu cơm ngon canh ngọt cho mà ăn. Lười ra ngoài nhưng chăm người yêu số 1! 🍳',
  },
};

export const SINGLE_RESULTS = {
  A: {
    title: 'Hội Trưởng Hội Kén Chọn',
    shareTitle: '#ĐỘC_THÂN_QUÝ_TỘC',
    temperature: '-5°C',
    temperatureLabel: 'Chớm lạnh',
    shareHook:
      'Không phải tôi ế, là do thị trường chưa sản xuất ra người xứng đáng với cấu hình này thôi. Tiêu chuẩn cao thì có gì là sai? 😎',
    analysis:
      'Bạn không hề thiếu sức hút hay cơ hội, mà bạn sở hữu một "bộ lọc" tiêu chuẩn cực kỳ khắt khe. Bạn tự chủ, độc lập về tài chính và có gu thẩm mỹ cao. Bạn thà chịu đựng sự cô đơn trong hoàng nhoáng còn hơn phải "hạ giá" bản thân cho một mối quan hệ mập mờ, không rõ ràng hoặc lệch pha về tư duy. Bạn có xu hướng quét và tìm "điểm trừ" của đối phương rất nhanh để chủ động rút lui trước nhằm bảo vệ quỹ thời gian của mình.',
    matchmakerAdvice:
      'Tiêu chuẩn cao là tốt để lọc bớt "rác" tình cảm, nhưng đôi khi hệ thống lọc của bạn quá nhạy khiến bạn bỏ lỡ những viên ngọc thô cần thời gian để tỏa sáng. Hãy thử giữ lại 1 tiêu chuẩn cốt lõi (ví dụ: Sự chân thành/Trí tuệ), và nới lỏng 2 tiêu chuẩn mềm (ví dụ: Ngoại hình chuẩn gymrat hoặc cách nhắn tin mở màn). Hãy cho đối phương cơ hội ở buổi hẹn thứ hai trước khi bấm nút "loại".',
  },
  B: {
    title: 'Đại Sứ Cẩn Trọng',
    shareTitle: '#CÀNH_CONG_SỢ_CHIM',
    temperature: '-35°C',
    temperatureLabel: 'Đóng băng tự vệ',
    shareHook:
      'Trái tim này tạm thời đóng cửa để bảo trì sau những cơn giông bão. Cần tìm một người đủ kiên nhẫn, đủ ấm áp đến để cùng làm tan chảy lớp băng này... 🩹',
    analysis:
      'Bản chất bạn là người giàu tình cảm, nhưng những vết xước từ quá khứ (bị phản bội, bị cắm sừng hoặc đột ngột bị ghosting) đã biến bạn thành một chú chim sợ cành cong. Bạn dựng lên một bức tường thành quá dày và luôn nhìn người mới với ánh mắt hoài nghi: "Liệu người này có thật lòng không hay lại là một trap-boy?". Bạn thà chọn sự cô đơn an toàn còn hơn mạo hiểm để rồi phải chịu tổn thương thêm một lần nữa.',
    matchmakerAdvice:
      'Bức tường thành giúp bạn an toàn nhưng nó cũng chặn đứng những người tốt muốn tiếp cận bạn. Bạn không cần phải vội vã vứt bỏ lớp phòng thủ, điều bạn cần là một mối quan hệ đi theo lộ trình "Chậm mà chắc". Hãy để dịch vụ mai mối độc quyền của chúng tôi làm màng lọc tư cách ứng viên, bảo đảm đối phương nghiêm túc 100% trước khi giới thiệu để bạn an tâm mở lòng theo nhịp điệu của riêng mình.',
  },
  C: {
    title: 'Nghiện Nhà Kinh Niên',
    shareTitle: '#CHIẾN_THẦN_Ủ_KÉN',
    temperature: '-70°C',
    temperatureLabel: 'Đóng băng vĩnh cửu',
    shareHook:
      'Thần tình yêu gõ cửa trúng ngay lúc tôi đang bận ngủ nướng và cày phim. Ai có lòng thì tự dắt tôi ra khỏi nhà đi chứ tôi lười làm quen lắm rồi! 🛌',
    analysis:
      'Lời nguyền độc thân của bạn không nằm ở ngoại hình hay tiền bạc, mà nằm ở chữ "LƯỜI". Bạn bị nghiện không gian an toàn của chiếc giường, thói quen xem phim, nuôi mèo và lướt mạng cuối tuần. Vòng tròn xã hội của bạn gần như đóng băng vì bạn lười phải khoác áo chỉn tề đi hẹn hò đại trà, lười phải trả lời những câu hỏi làm quen lặp đi lặp lại như "Em ăn cơm chưa", "Đang làm gì thế". Bạn muốn có người yêu nhưng lại không muốn ra đường.',
    matchmakerAdvice:
      'Xác suất để một định mệnh tự va vào bạn khi bạn chỉ ở nhà là thấp hơn trúng xổ số. Bản chất bạn là người của gia đình, cực kỳ ấm áp. Vì bạn lười đi tìm, hãy để chúng tôi làm việc đó thay bạn. Bạn không cần tốn năng lượng quẹt app đại trà, chỉ cần ngồi im ở nhà, Matchmaker sẽ sàng lọc, chọn đúng người cùng tần số "thích chill/bình yên" và dắt đến tận tay bạn trong một buổi hẹn private được thiết kế riêng.',
  },
};

export const defaultFormData = {
  email: '', pin: '', fullName: '', nickname: '', dob: '', city: '', address: '',
  height: '', weight: '', bodyType: '', education: '', income: '', job: '',
  currentStatus: '', livingSpace: '',
  orientation: '', role: [] as string[], comingOut: '', rel: [] as string[],
  personality: [] as string[], pros: [] as string[], cons: [] as string[], substances: [] as string[],
  energy: '', lifestyle: '', hobbies: [] as string[], love: [] as string[],
  futurePlans: [] as string[], futureKids: '', financeShared: [] as string[], financeMindset: [] as string[], sexView: [] as string[],
  age: [] as string[], partnerRole: [] as string[], partnerBody: [] as string[], priority: '', redflag: [] as string[],
  messageToAdmin: '', avatar: [] as string[], socialLink: '', idCard: '',
  extraDetails: {
    additionalAnswers: {} as Record<string, string>,
    personalityResult: null as {
      title: string;
      desc: string;
      shareTitle: string;
      shareHook: string;
      typeKey: string;
      variantKey?: string;
      percent: number;
      answers: Record<number, string>;
    } | null,
    singleResult: null as {
      title: string;
      desc: string;
      shareTitle: string;
      shareHook: string;
      typeKey: string;
      variantKey?: string;
      percent: number;
      temperature: string;
      temperatureLabel: string;
      triggerTagD: boolean;
      tagDSupplement?: string;
      answers: Record<number, string>;
    } | null,
    bedroomResult: null as {
      title: string;
      desc: string;
      shareTitle: string;
      shareHook: string;
      typeKey: string;
      variantKey?: string;
      percent: number;
      answers: Record<number, string>;
    } | null
  }
};
